export default "__VITE_ASSET__DNcliLM5__"